module.exports = __webpack_public_path__ + "img/down2.2f132803.svg";